import Captcha from './captcha';
import { install } from '../utils/install';
export default install(Captcha);
